import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ImageFieldSchema,
  RichTextFieldSchema,
  UrlFieldSchema,
} from './Types';
import { z } from 'zod';

const FooterLinkTextField = RichTextFieldSchema.extend({
  name: z.literal('linkText'),
  role: z.literal(FieldRole.CtaText),
});

const FooterLinkUrlField = UrlFieldSchema.extend({
  name: z.literal('linkUrl'),
  role: z.literal(FieldRole.CtaUrl),
});

const FooterLogoUrlField = ImageFieldSchema.extend({
  name: z.literal('logoUrl'),
  role: z.literal(FieldRole.Logo),
});

const FooterBlockFieldSchema = z.discriminatedUnion('name', [FooterLogoUrlField]);

const FooterLinkFieldSchema = z.discriminatedUnion('name', [FooterLinkTextField, FooterLinkUrlField]);

const FooterBlockFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(FooterBlockFieldSchema),
});

const FooterLinkFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(FooterLinkFieldSchema),
});

const FooterStyleOptionsSchema = z.object({
  backgroundColor: z.string().optional(),
});

const FooterOptionsSchema = z.object({
  style: FooterStyleOptionsSchema.optional(),
  entryCount: z.number().optional(),
  layout: z.literal('standard').optional(),
  colorScheme: ColorSchemeSchema.optional(),
});

export const FooterBlockConfigSchema = z.object({
  options: FooterOptionsSchema,
  type: z.literal(BlockType.Footer),
  fieldGroups: z.tuple([FooterBlockFieldGroupSchema]).rest(FooterLinkFieldGroupSchema),
  version: z.literal(1),
});
